export default __webpack_public_path__ + "static/bouncing-ball-spritesheet-01908087d6ab41470a8ecf5bae8be49b.png";